export default __webpack_public_path__ + "static/media/pic-3.fa689b10.jpg";